import { render, staticRenderFns } from "./TreesFive.vue?vue&type=template&id=f1b98742&scoped=true&"
var script = {}
import style0 from "./TreesFive.vue?vue&type=style&index=0&id=f1b98742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b98742",
  null
  
)

export default component.exports